import {
  Box,
  Typography,
  Container,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@mui/material';

const Recruit = () => {
  const data = [
    { title: '雇用形態', value: '正社員' },
    { title: '募集職種', value: '・システムエンジニアリングサービス　SE、PG・開発、インフラジャンル問わず、若手(経験1年以上)～即戦力まで幅広く' },
    { title: '歓迎', value: '・将来的に自社サービスの企画立案・プロジェクト推進を実行する意欲のある方・組織の中核人材として会社の成長をリードしていく方' },
    { title: '勤務地', value: '関東圏　参画案件次第' },
    { title: '休日', value: '完全週休2日制（土・日）、祝日、有給休暇' },
    { title: '給与', value: '参画案件により給与変動・案件単価の60%を基本給として設定・例）単価60万円の案件参画・60万円　×　60%　＝基本給　36万円' },
    { title: '福利厚生', value: '各種社会保険完備（健康保険、厚生年金保険、労災保険、雇用保険）交通費支給 リモートワーク補助金 会社負担生命保険加入制度' },
  ];

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center', // 👈 PCや大画面スマホでは中央寄せ
        textAlign: "center",
        height: '100vh',         // 👈 画面ぴったりに固定
        width: '100%',
        overflow: 'hidden',      // 👈 全体がスクロールするのを防ぐ
        boxSizing: 'border-box',
        pt: { xs: '64px', md: '80px' }, // ヘッダー分
        pb: '20px',
      }}
    >
      <Box sx={{ 
        width: '94%', 
        maxWidth: '800px',
        maxHeight: '100%',       // 👈 画面の高さ以上に広がらないように
        display: 'flex',
        flexDirection: 'column',
      }}> 
        <Box sx={{ mb: { xs: 1.5, md: 4 }, flexShrink: 0 }}>
          <Typography variant="h4" sx={{ 
            fontSize: { xs: "36px", md: "40px" }, 
            fontFamily: "'Noto Serif JP', serif", 
          }}>
            Recruit
          </Typography>
          <Typography 
            variant="h5" 
            gutterBottom 
            sx={{ 
              fontFamily: "'Noto Serif JP', serif",
              fontSize: { xs: "1.5rem", md: "1.5rem" } 
            }}
          >
            採用
          </Typography>
        </Box>
        
        {/* 👈 ポイント：表のエリアだけをスクロール可能にする */}
        <Box sx={{ 
          overflowY: 'auto', 
          width: '100%',
          border: '1px solid #eee',
          borderRadius: '4px',
          // スクロールバーを隠す（任意）
          '&::-webkit-scrollbar': { width: '4px' },
          '&::-webkit-scrollbar-thumb': { backgroundColor: '#ccc', borderRadius: '4px' }
        }}>
          <Table
            size="small" 
            sx={{
              width: '100%',
              tableLayout: 'fixed',
              backgroundColor: '#fff',
            }}
          >
            <TableBody>
              {data.map((item, index) => (
                <TableRow key={index}>
                  <TableCell
                    sx={{
                      fontSize: { xs: '10px', md: '14px' }, // 極限まで小さく
                      fontWeight: 'bold',
                      backgroundColor: '#f9f9f9',
                      width: { xs: '70px', md: '180px' },
                      padding: { xs: '8px 4px', md: '16px 20px' },
                      wordBreak: 'break-all',
                      borderBottom: '1px solid #eee',
                    }}
                  >
                    {item.title}
                  </TableCell>
                  <TableCell 
                    sx={{ 
                      fontSize: { xs: '11px', md: '14px' },
                      padding: { xs: '8px', md: '16px 20px' },
                      borderBottom: '1px solid #eee',
                      wordBreak: 'break-all',
                    }}
                  >
                    {item.title === '歓迎' || item.title === "募集職種" || item.title === "給与" ? (
                      item.value
                        .split('・')
                        .filter(val => val.trim() !== '')
                        .map((val, i) => (
                          <Typography key={i} component="div" sx={{ 
                            fontSize: 'inherit', 
                            lineHeight: 1.4,
                            mb: 0.3,
                            display: 'flex',
                            '&::before': { flexShrink: 0 }
                          }}>
                            {val}
                          </Typography>
                        ))
                    ) : (
                      item.value
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Container>
  );
};

export default Recruit;
